module.exports = __webpack_public_path__ + "static/img/front-SFG124.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/_front/front-SFG124.png
// module id = Ivbl
// module chunks = 0